import { render } from "./Produccion.vue?vue&type=template&id=260a99ee"
import script from "./Produccion.vue?vue&type=script&lang=js"
export * from "./Produccion.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/helados_admin_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__